/**
 * SSE/stream parçalarını birleştirir. Sunucu chunk sınırında boşluk göndermediğinde
 * kelimeler yapışmasın diye sınırda (gerektiğinde) tek boşluk eklenir.
 */
export function joinStreamTextFragments(previous: string, incoming: string): string {
  if (!incoming) return previous;
  if (!previous) return incoming;

  // "...cümle." + "**2. Başlık" — chunk sınırında numaralı kalın madde yapışık
  if (/[.!?]\s*$/.test(previous) && /^\*\*[1-9]\d*\.\s/.test(incoming)) {
    return `${previous}\n\n${incoming}`;
  }

  // "...gerekir." + "## SBAR" — nokta ile markdown başlığı yapışınca H2 tanınmaz
  const incTrim = incoming.trimStart();
  if (/^#{1,6}(\s|$)/.test(incTrim)) {
    if (previous.length > 0 && !/\n$/.test(previous)) {
      return `${previous}\n\n${incoming.trimStart()}`;
    }
  }

  // Markdown başlık satırı ile gövde chunk sınırında yapışmasın (ör. #### ... + Hasta...)
  if (/(?:^|\n)(#{1,6}\s[^\n]+)$/.test(previous)) {
    const inc = incoming.trimStart();
    if (
      /^[A-Za-zÇĞİÖŞÜçğıöşüİı0-9]/.test(inc) ||
      /^\*\*/.test(inc) ||
      /^[-*]\s/.test(inc) ||
      /^\d+\.\s/.test(inc)
    ) {
      return `${previous}\n\n${incoming}`;
    }
  }

  const last = previous.slice(-1);
  const first = incoming[0];

  if (/\s/.test(last) || /\s/.test(first)) {
    return previous + incoming;
  }

  const isLetter = (c: string) => /[a-zA-ZçğıöşüÇĞİÖŞÜİı]/.test(c);

  if (isLetter(last) && isLetter(first)) {
    return `${previous} ${incoming}`;
  }

  if (/[.!?:;,)]/.test(last) && isLetter(first)) {
    return `${previous} ${incoming}`;
  }

  return previous + incoming;
}
